import type { ButtonHTMLAttributes } from "react";
import styles from "./Switch.module.css";
import { cx } from "../cx";

export type SwitchProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> & {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
};

/** SEED Switch (Figma 59:1166). 44×26. */
export function Switch({ checked, onCheckedChange, className, disabled, ...rest }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={cx(styles.root, checked && styles.on, className)}
      onClick={() => onCheckedChange(!checked)}
      {...rest}
    >
      <span className={styles.thumb} />
    </button>
  );
}
